export default "__VITE_ASSET__BhAS6e8D__"